import { Key, Entity } from '@briebug/ngrx-auto-entity';

@Entity({ modelName: 'BidItem' })
export class BidItem {
  @Key id?: string;
  bid: string;
  section: string;
  label: string;
  equipmentType: number;
  description: string;
  size: string;
  depth: string;
  quantity: number;
  unitPrice: number;
  notes: string;
  sortOrder: number;
}
